import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getJobApi = createAsyncThunk('getjobStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingJobDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllJobs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(jobDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(jobDetailClear())
                message.error(error) 
            })
    }
)


export const updateJobStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateJobStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(jobstatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const GetJobApiSlice = createSlice({
    name: 'Jobgetapi',
    initialState: {
        jobData: null,
        loadingjob: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingJobDetail: state => {
            state.loadingjob=true
            state.jobData=null
        },
        jobDetailResponse: (state, action)=>{
            state.jobData= action.payload
            state.loadingjob= false
        },
        jobDetailClear: (state)=>{
            state.jobData= null
            state.loadingjob= false
        },
        changeJobDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        jobstatusResponse: (state, action) => {
            const { id, status } = action.payload
            const jobIndex = state.jobData.findIndex(jb => jb.id === id)
            if (jobIndex !== -1) {
                state.jobData[jobIndex].status = status
            }
            state.loadingjob = false
        }
    },
})
export const { 
    gettingJobDetail, jobDetailResponse, jobDetailClear,
    changeJobDetailFilters, setPages, jobstatusResponse
} = GetJobApiSlice.actions;
export default GetJobApiSlice.reducer;